export default __webpack_public_path__ + "static/media/Shadow's Cord of Ushering Twilight.77545edd.jpg";